import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {SipHeadersService} from '../../../../services/common/sip-headers/sip-headers.service';
import * as _ from 'lodash';
import {AbstractControl, FormControl, NgForm, Validators} from '@angular/forms';

class ValidationErrors {
}

@AcDialog({
  id: 'sipManipulationGroups',
  height: 540,
  width: 1300
})
@Component({
  selector: 'sip-manipulation-groups-dialog',
  templateUrl: './sip-manipulation-groups-dialog.component.html',
  styleUrls: ['./sip-manipulation-groups-dialog.component.scss']
})
export class SipManipulationGroupsDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('sipManipulationForm') sipManipulationForm: NgForm;

  data: any;
  sipConditionGroups;
  headerStructure;
  actionsOptions;
  subjectSuggestions;
  normalizationGroupsOptions;
  prefixGroupsOptions;
  customWebServices;
  requestMethodsOptions;
  contentTypeOptions;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private sipHeadersService: SipHeadersService) {
    this.data = dialogConfig.dialogData.data;
    this.sipConditionGroups = dialogConfig.dialogData.sipConditionGroups;
    this.customWebServices = dialogConfig.dialogData.customWebServices;
    this.headerStructure = dialogConfig.dialogData.headerStructure;
    this.actionsOptions = dialogConfig.dialogData.actionsOptions;
    this.requestMethodsOptions = dialogConfig.dialogData.requestMethodsOptions;
    this.contentTypeOptions = dialogConfig.dialogData.contentTypeOptions;
    this.normalizationGroupsOptions = dialogConfig.dialogData.normalizationGroupsOptions;
    this.prefixGroupsOptions = this.dialogConfig.dialogData.prefixGroupsOptions;

    this.dialogConfig.preSubmit = () => {
      this.data.manipulations.map((manipulation, i) => {
        manipulation.priority = ++i;

        if (manipulation.actionType === 'normalization' || manipulation.actionType === 'remove') {
          manipulation.actionValue = '';
        } else {
          manipulation.normalizationGroupId = null;
        }
        if (manipulation.actionType !== 'sendByWebService') {
          this.resetHttpRequestFields(manipulation);
        } else {
          if (manipulation.requestMethod === 'GET') {
            manipulation.requestBody = null;
          }
        }
        delete manipulation.subjectControl;
        delete manipulation.actionTypeError;
        delete manipulation.actionsOptions;
      });
    };

    this.initializeData();
  }

  ngOnInit(): void {
    this.isManipulationGroupValid();
  }

  ngAfterViewInit(): void {
    this.sipManipulationForm.form.statusChanges.subscribe(() => {
      this.isManipulationGroupValid();
    });
  }

  agentTypeSelected(): void {
  }

  addManipulation(): void {
    this.data.manipulations.push({
      subjectControl: new FormControl('', [
        Validators.required, this.subjectValidator()
      ])
    });
  }

  moveRuleUp(index): void {
    this.swapManipulationRules(index, --index);
  }

  moveRuleDown(index): void {
    this.swapManipulationRules(index, ++index);
  }

  removeRuleDown(index): void {
    this.data.manipulations.splice(index, 1);
  }

  private swapManipulationRules(index1, index2): void {
    const tempRule = this.data.manipulations[index1];

    this.data.manipulations[index1] = this.data.manipulations[index2];
    this.data.manipulations[index2] = tempRule;
  }

  isManipulationGroupValid(): void {
    let isDialogValid = false;

    if (_.isNil(this.data.name)) {
      isDialogValid = true;
    }

    this.data.manipulations.forEach(manipulation => {
      if (!this.sipHeadersService.generateActionsForHeader(manipulation.actionSubject)) {
        isDialogValid = true;
      }

      if (_.isEmpty(manipulation.actionType)) {
        isDialogValid = true;
      }

      if (!['normalization', 'remove', 'randomFromPool', 'sendByWebService'].includes(manipulation.actionType) &&
        _.isEmpty(manipulation.actionValue)) {
        isDialogValid = true;
      } else if ((manipulation.actionType === 'normalization') && _.isNil(manipulation.normalizationGroupId)) {
        isDialogValid = true;
      } else if ((manipulation.actionType === 'randomFromPool') && _.isNil(manipulation.prefixGroupId)) {
        isDialogValid = true;

      } else if (manipulation.actionType === 'sendByWebService') {
        if (_.isNil(manipulation.webServiceId)) {
          isDialogValid = true;
        } else if (_.isNil(manipulation.requestMethod)) {
          isDialogValid = true;
        } else if (_.isNil(manipulation.requestContentType)) {
          isDialogValid = true;
        }
      }
    });

    this.dialogConfig.submitButtonDisabled = isDialogValid;
  }

  onAddValueApply(data): void {
    data.group.actionValue = data.customValue;
    this.isManipulationGroupValid();
  }

  onAddSuffixApply(data): void {
    data.group.requestUrlSuffix = data.customValue;
    this.isManipulationGroupValid();
  }

  onAddBodyApply(data): void {
    data.group.requestBody = data.finalBody;
    this.isManipulationGroupValid();
  }

  onJsonApply(date): void {

  }

  normalizationFocusout(manipulation): void {
    manipulation.normalizationError = _.isNil(manipulation.normalizationGroupId) ? 'Normalization group is required' : null;
  }

  prefixGroupFocusout(manipulation: any): void {
    manipulation.prefixGroupError = _.isNil(manipulation.prefixGroupId) ? 'Prefix group is required' : null;
  }

  updateSubjectSuggestions($event: any = '', manipulation = null): void {
    this.subjectSuggestions = this.sipHeadersService.generateSubjectManipulationSuggestions($event);

    if (manipulation) {
      manipulation.actionsOptions = this.sipHeadersService.generateActionsForHeader($event);

      if (_.isNil(manipulation.actionsOptions) || (manipulation.actionsOptions && !_.isNil(manipulation.actionType) &&
        !manipulation.actionsOptions.find(item => item.value === manipulation.actionType))) {
        manipulation.actionType = '';
      }
    }
  }

  actionFocusout(manipulation): void {
    manipulation.actionTypeError = _.isNil(manipulation.actionType) ? 'Action Type is required' : null;
  }

  subjectValidator(): any {
    return (control: AbstractControl): ValidationErrors | null => {
      return _.isEmpty(this.sipHeadersService.generateActionsForHeader(control.value)) ? {error: 'Invalid Subject'} : null;
    };
  }

  private initializeData(): void {
    this.data.manipulations.map(manipulation => {
      manipulation.subjectControl = new FormControl('', [
        Validators.required, this.subjectValidator()
      ]);
    });
  }

  private resetHttpRequestFields(manipulation): void  {
    manipulation.webServiceId = null;
    manipulation.requestMethod = null;
    manipulation.requestContentType = null;
    manipulation.requestBody = null;
    manipulation.requestUrlSuffix = null;

  }
  private setContentTypeAutomatically(manipulation): void  {
    if (manipulation.requestMethod === 'GET')
    {
      manipulation.requestContentType = 'NONE';
    }
  else
    {
      manipulation.requestContentType = 'APPLICATION_JSON';
    }

  }
}
